import {
    getDataTable,
    getDataTableForRegularPrices,
} from "../../Redux/content-reducer";
import {connect} from "react-redux";
import {ScreenSearch} from "./ScreenSearch";



let mapStateToProps = (state) => {
    return {
        data: state
    }
};

let mapDispatchToProps = {
    getDataTable, getDataTableForRegularPrices,
};


export default connect(mapStateToProps, mapDispatchToProps)(ScreenSearch);
